import React, { useLayoutEffect } from "react";
import { IntlProvider } from "react-intl";
import { ThemeProvider as SCThemeProvider } from "styled-components";
import { SnackbarProvider } from "notistack";
import { QueryClientProvider, QueryClient } from "react-query";
import { CssBaseline } from "@material-ui/core";
import { createTheme, MuiThemeProvider, StylesProvider } from "@material-ui/core/styles";
import App from "./App";
import { createBASFTheme } from "./theme/BasfTheme";
import { DEFAULT_LOCALE } from "./modules/locale/config";
import { useLocale } from "./modules/locale/hooks/useLocale";
import "typeface-lato";
import { registerInterceptors } from "./modules/http";
import { DialogProvider } from "./modules/common";

export const theme = createTheme(createBASFTheme());
export const queryClient = new QueryClient();

export const Root: React.FC = () => {
  const { locale, currentTranslations } = useLocale();
  return (
    //   <HightChartsThemeProvider>
    <IntlProvider locale={DEFAULT_LOCALE} key={locale} messages={currentTranslations}>
      <QueryClientProvider client={queryClient}>
        <MuiThemeProvider theme={theme}>
          <StylesProvider injectFirst>
            <SCThemeProvider theme={theme}>
              <SnackbarProvider maxSnack={3} autoHideDuration={3000}>
                <DialogProvider>
                  <CssBaseline />
                  <App />
                </DialogProvider>
              </SnackbarProvider>
            </SCThemeProvider>
          </StylesProvider>
        </MuiThemeProvider>
      </QueryClientProvider>
    </IntlProvider>
    //   </HightChartsThemeProvider>
  );
};
